'use client'

import dynamic from 'next/dynamic'

export const UnlimitedCreativityModal = dynamic(
  () => import('./unlimited-creativity-modal').then(mod => mod.UnlimitedCreativityModal),
  {
    ssr: false,
  },
)
